var _dec, _dec2, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import LatestCatalogObject from '@square/dashboard-items-data/adapters/connect/latest-catalog-object';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { MULTIPLE_IMAGES_API_VERSION as SUBSCRIPTION_PLAN_API_VERSION } from '@square/dashboard-items-data/adapters/connect/image';
import { SUBSCRIPTION_ITEMIZATION_API_VERSION } from '@square/dashboard-items-data/models/connect/subscription-plan';
import { isNone } from '@ember/utils';
import { CatalogQuery, CatalogQuerySet, CatalogQueryRange, CatalogSortedAttributeQuery } from '@square/dashboard-items-data/clients/catalog-connect-v2';

// Remove async itemization status ASAP
let SubscriptionPlan = (_dec = service('buyer-subs/itemization-status'), _dec2 = computed('itemizationStatus.isItemized'), (_class = class SubscriptionPlan extends LatestCatalogObject {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "features", _descriptor, this);
    _initializerDefineProperty(this, "itemizationStatus", _descriptor2, this);
  }
  shouldBackgroundReloadRecord(store, snapshot) {
    return snapshot?.id?.[0] !== '#';
  }
  get headers() {
    if (this.itemizationStatus.isItemized || this.features.isEnabled('buyersubs/updated_legacy_api_version')) {
      return {
        'Square-Version': SUBSCRIPTION_ITEMIZATION_API_VERSION
      };
    } else {
      return {
        'Square-Version': SUBSCRIPTION_PLAN_API_VERSION
      };
    }
  }
  query(store, type, query) {
    const adapterOptions = query.adapterOptions || {};
    const queryObj = {};
    if (isNone(query.adapterOptions)) {
      return super.query(store, type, query, {
        headers: this.headers
      });
    }
    if (!isNone(query.adapterOptions?.itemIds)) {
      queryObj.setQuery = CatalogQuerySet.create({
        attributeName: 'item_id',
        attributeValues: query.adapterOptions.itemIds
      });
    } else if (query.adapterOptions.allItems) {
      queryObj.rangeQuery = CatalogQueryRange.create({
        attributeName: 'all_items',
        attributeMinValue: 1,
        attributeMaxValue: 1
      });
    }
    if (adapterOptions.sort) {
      queryObj.sortedAttributeQuery = CatalogSortedAttributeQuery.create({
        attributeName: adapterOptions.sort.sortKey
      });
    }
    if (Object.keys(queryObj).length > 0) {
      query.query = CatalogQuery.create(queryObj);
    }
    if (query.adapterOptions.limit) {
      query.limit = query.adapterOptions.limit;
    }
    delete query.adapterOptions;
    return super.query(store, type, query, {
      headers: this.headers
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "itemizationStatus", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "headers", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "headers"), _class.prototype)), _class));
export { SubscriptionPlan as default };